// extracted by mini-css-extract-plugin
module.exports = {"singleArticleRoot":"YNAvHbRt","title":"AuFWRumS","meta":"Jg6U7zMi","metaItem":"KP5Bg5Nv","assetChips":"LCjFrNV5","contentSkeletonWrapper":"EZVQKfa7","viewMoreButton":"jpFiCk1I"};